<template><section><h3>图表介绍</h3>
<p>Wave, 水波图</p>
<h3>属性 attr</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>clientRect</td>
<td>Object</td>
<td>{top,right,bottom,left,width,height}</td>
</tr>
<tr>
<td>percent</td>
<td>百分比</td>
<td></td>
</tr>
<tr>
<td>animation</td>
<td>动画配置</td>
<td></td>
</tr>
<tr>
<td>formatter</td>
<td>文本格式化</td>
<td><code v-pre>(fn: Function)</code></td>
</tr>
</tbody>
</table>
<h3>样式</h3>
<p>组件中可以自定义 css 属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基础类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>wave</td>
<td>面</td>
<td>水波图形的样式</td>
</tr>
<tr>
<td>shape</td>
<td>面</td>
<td>水波背景的样式</td>
</tr>
<tr>
<td>text</td>
<td>文本</td>
<td>文本的样式</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>